// Character set for replacement
const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const scrambleText = (text: string, shouldScramble: boolean): string => {
  if (!shouldScramble) {
    return text;
  }

  return text.replace(/\S/g, (char, index) => {
    const seed = char.charCodeAt(0) + index;
    const replacementIndex = seed % characters.length;
    return characters.charAt(replacementIndex);
  });
};
